// radians(deg) - converts from degrees to radians

const ratio = Math.PI / 180;

export const radians = (deg) => deg * ratio;
export const degrees = (rad) => rad / ratio;
